import { combineReducers } from 'redux';

import { Order } from '@pegasus/types/order';

import { defineFetchCollectionWithNextForNamespace } from '../../../shared/redux/fetch/collection';
import { fetchOrders, FetchOrdersParams } from '../../service';

import { NAMESPACE } from './constants';
import { reducer as viewReducer, State as ViewState } from './reducers';

const NAME = 'data';

const {
    reducer,
    getIsInitial,
    getIsLoading,
    getHasNext,
    getData,
    fetchData,
    fetchNextData,
    getInitialState,
} = defineFetchCollectionWithNextForNamespace<
    Order,
    string | FetchOrdersParams,
    typeof NAMESPACE,
    typeof NAME
>(NAMESPACE, NAME, (params: string | FetchOrdersParams) => fetchOrders(params));

type CombinedState = ViewState & ReturnType<typeof getInitialState>;

const combinedReducers = combineReducers({
    [NAME]: reducer,
    view: viewReducer,
});

const getOrderListReducer = () => ({
    [NAMESPACE]: combinedReducers,
});

export {
    getOrderListReducer,
    getIsInitial,
    getIsLoading,
    getHasNext,
    getData as getOrders,
    fetchData as fetchOrders,
    fetchNextData as fetchNextOrders,
};

export { setFilter } from './actions';
export { getFilter } from './selectors';
